export const CONNECTION_GAME = [
  {
    category: "Favorite local restaurants",
    words: ["Nolita",	"Miku",	"Cafe Besalu",	"La Cuadra"],
    difficulty: 1,
  },
  {
    category: "Found in Mexico",
    words: ["Tacos",	"Beach",	"Avocado",	"Tequila"],
    difficulty: 2,
  },
  {
    category: "Colors of the sunset",
    words: ["Peach",	"Salmon",	"Gold",	"Coral"],
    difficulty: 3,
  },
  {
    category: "Contains double letters",
    words: ["Wakkanai",	"Niigata",	"Waffles",	"Pizza"],
    difficulty: 4,
  },
];
